import {
    Button,
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle, Input,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems, Select, Textarea
} from '@headlessui/react'
import {
    ChevronDownIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ClockIcon,
    EllipsisHorizontalIcon,
} from '@heroicons/react/20/solid'
import {useDarkMode} from "../../contexts/darkModeContext";
import {generateCalendarDays, getUSHolidays} from "../GlobalFunctions";
import {format} from 'date-fns';
import React, {useEffect, useState} from "react";
import {ArrowLeftIcon, PlusIcon} from "@heroicons/react/16/solid";
import {
    ArrowRightIcon,
    CalendarDateRangeIcon,
    CalendarDaysIcon,
    TrashIcon, XCircleIcon
} from "@heroicons/react/24/outline";
import {db} from "../../firebase/firebase";
import {useAuth} from "../../contexts/authContext";
import {Link} from "react-router-dom";


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const MonthView = () => {

    const { darkMode } = useDarkMode();
    const { currentUser } = useAuth();

    const [timeMachine, setTimeMachine] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);

    const today = new Date();
    const [year, setYear] = useState(today.getFullYear());
    const [month, setMonth] = useState(today.getMonth()); // 0-indexed

    const handlePrevMonth = () => {
        if (month === 0) {
            setMonth(11);
            setYear(prev => prev - 1);
        } else {
            setMonth(prev => prev - 1);
        }
    };

    const handleNextMonth = () => {
        if (month === 11) {
            setMonth(0);
            setYear(prev => prev + 1);
        } else {
            setMonth(prev => prev + 1);
        }
    };

    const handleResetToToday = () => {
        setYear(today.getFullYear());
        setMonth(today.getMonth());
    };


    const [customEvents, setCustomEvents] = useState([]);


    // const customEvents = [
    //     {
    //         name: 'First Tee Time',
    //         date: new Date(2025, 3, 10), // April 10
    //         time: '8AM',
    //         datetime: '2025-04-10T08:00',
    //         href: '#',
    //     },
    //     {
    //         name: 'Greens Aeration',
    //         date: new Date(2025, 3, 15),
    //         time: 'All Day',
    //         datetime: '2025-04-15T00:00',
    //         href: '#',
    //     },
    //     {
    //         name: 'Round Table Discussion',
    //         date: new Date(2025, 3, 23),
    //         time: '9AM',
    //         datetime: '2025-04-23T09:00',
    //         href: '#',
    //     },
    // ];








    const [editingId, setEditingId] = useState(null);

    const [formData, setFormData] = useState({
        name: '',
        date: '',
        time: '',
        type: '',
        notes: '',
    });

    // const fillFormWithEventData = (event) => {
    //     setFormData({
    //         name: event.name,
    //         date: event.date,
    //         time: event.time,
    //         type: event.type,
    //         notes: event.notes,
    //     });
    //     setEditingId(event.id);
    // };

    const clearForm = () => {
        setFormData({
            name: '',
            date: '',
            time: '',
            type: '',
            notes: '',
        });
        setEditingId(null);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const addOrUpdateButtonText = editingId ? 'Update Event' : 'Add Event';
    const currentDate = new Date().toLocaleDateString('en-US').split('/').join('-');

    const handleSubmit = async (e) => {
        e.preventDefault();
        const collectionRef = db.collection('Users').doc(currentUser.uid).collection('events');

        // If date field is empty, set it to the current date
        const currentDate = new Date().toLocaleDateString('en-US').split('/').join('-');
        const formDataWithDate = {
            ...formData,
            date: formData.date || currentDate
        };

        try {
            if (editingId) {
                await collectionRef.doc(editingId).update(formDataWithDate);
                console.log('Event updated successfully!');
                // await onUpdate();
            } else {
                await collectionRef.add(formDataWithDate);
                console.log('Event added successfully!');
                // await onUpdate();
            }

            clearForm(); // Clear the form after submission
        } catch (error) {
            console.error('Error adding/updating Event: ', error);
        }
    };



    useEffect(() => {
        const fetchEvents = async () => {
            if (currentUser) {
                try {
                    const CollectionRef = db
                        .collection('Users')
                        .doc(currentUser.uid)
                        .collection('events');

                    const snapshot = await CollectionRef.get();

                    if (!snapshot.empty) {
                        const Data = snapshot.docs.map(doc => {
                            const data = doc.data();

                            // Convert date string "YYYY-MM-DD" to JS Date object
                            if (data.date) {
                                const [year, month, day] = data.date.split('-').map(Number);
                                data.date = new Date(year, month - 1, day); // JS months are 0-based
                            }

                            return {
                                id: doc.id,
                                ...data,
                                custom: true, // ✅ Add custom flag
                            };
                        });

                        setCustomEvents(Data);

                        console.log("Fetched events:", Data); // Log converted and enriched event data
                    } else {
                        console.log('No events found');
                    }
                } catch (error) {
                    console.error('Error fetching events:', error);
                }
            }
        };
        fetchEvents()
    }, [currentUser]);





    // Combine holidays and custom events
    const allEvents = [...getUSHolidays(year), ...customEvents];
    const days = generateCalendarDays(year, month, allEvents);

    const monthYearLabel = format(new Date(year, month, 1), 'MMMM yyyy');
    const selectedDay = days.find((day) => day.isSelected)

    const numberOfRows = Math.round(days.length / 7);
    const gridRowClass = `lg:grid-rows-${numberOfRows}`;


    const MONTHS = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const YEARS = Array.from({ length: 51 }, (_, i) => new Date().getFullYear() - 25 + i);

    return (
        <div className={`lg:flex h-full lg:flex-col ${darkMode ? 'text-white' : 'text-black'}`}>

            {/*Header*/}
            <header className="flex items-center justify-between pb-4 lg:flex-none">
                <h1 className="text-2xl font-semibold tracking-widest flex items-center gap-3">
                    <Button onClick={handleResetToToday}>
                        <CalendarDaysIcon className={`ml-6 size-6 text-green-600 hover:text-green-600 hover:animate-heartbeat`}/>
                    </Button>

                    <Button onClick={handlePrevMonth}>
                        <ArrowLeftIcon className={`size-6 text-gray-500 hover:text-green-600 hover:animate-pulse stroke-2`}/>
                    </Button>


                    <Button onClick={() => setTimeMachine(true)} className={`tracking-widest`}>
                        <time dateTime={`${year}-${String(month + 1).padStart(2, '0')}`}>
                            {monthYearLabel}
                        </time>
                    </Button>


                    <Button onClick={handleNextMonth}>
                        <ArrowRightIcon className={`size-6 text-gray-500 hover:text-green-600 hover:animate-pulse stroke-2`}/>
                    </Button>

                </h1>

                {/*Buttons*/}
                <div className="flex items-center">
                    <div className={`relative flex items-center rounded-md ${darkMode ? 'bg-bgDark' : 'bg-white'} shadow-sm md:items-stretch`}>
                        <Button
                            type="button"
                            className={`flex h-9 w-12 items-center justify-center rounded-l-md border-y border-l ${darkMode ? 'border-neutral-700' : 'border-gray-300'} pr-1 text-gray-500 hover:text-gray-500 focus:relative md:w-9 md:pr-0 md:hover:bg-gray-50`}
                        >
                            <span className="sr-only">Previous month</span>
                            <ChevronLeftIcon className="size-5" aria-hidden="true"/>
                        </Button>
                        <Button
                            type="button"
                            className={`hidden border-y ${darkMode ? 'border-neutral-700' : 'border-gray-300'} px-3.5 text-sm font-semibold hover:bg-gray-50 focus:relative md:block`}
                        >
                            Today
                        </Button>
                        <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden" />
                        <Button
                            type="button"
                            className={`flex h-9 w-12 items-center justify-center rounded-r-md border-y border-r ${darkMode ? 'border-neutral-700' : 'border-gray-300'} pl-1 text-gray-500 hover:text-gray-500 focus:relative md:w-9 md:pl-0 md:hover:bg-gray-50`}
                        >
                            <span className="sr-only">Next month</span>
                            <ChevronRightIcon className="size-5" aria-hidden="true" />
                        </Button>
                    </div>

                    {/*Buttons*/}
                    <div className="hidden md:ml-4 md:flex md:items-center">
                        <Menu as="div" className="relative">
                            <MenuButton
                                type="button"
                                className={`flex items-center gap-x-1.5 rounded-md border ${darkMode ? 'bg-bgDark border-neutral-700' : 'bg-white border-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50`}
                            >
                                Month view
                                <ChevronDownIcon className="-mr-1 size-5 text-gray-500" aria-hidden="true" />
                            </MenuButton>

                            <MenuItems
                                transition
                                className={`absolute right-0 z-10 mt-3 w-36 origin-top-right overflow-hidden rounded-md border ${darkMode ? 'bg-bgDark border-neutral-700' : 'bg-white border-gray-300'} shadow-2xl focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in`}
                            >
                                <div className="py-1">
                                    <MenuItem>
                                        <Button
                                            // href="#"
                                            className="block px-4 py-2 text-sm data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                        >
                                            Day view
                                        </Button>
                                    </MenuItem>
                                    <MenuItem>
                                        <Button
                                            // href="#"
                                            className="block px-4 py-2 text-sm data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                        >
                                            Week view
                                        </Button>
                                    </MenuItem>
                                    <MenuItem>
                                        <Button
                                            // href="#"
                                            className="block px-4 py-2 text-sm data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                        >
                                            Month view
                                        </Button>
                                    </MenuItem>
                                    <MenuItem>
                                        <Button
                                            // href="#"
                                            className="block px-4 py-2 text-sm data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                        >
                                            Year view
                                        </Button>
                                    </MenuItem>
                                </div>
                            </MenuItems>
                        </Menu>

                        <Button
                            type="button"
                            onClick={() => setIsCollapsed(true)}
                            className="ml-6 rounded-md flex items-center bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                        >
                            <PlusIcon className={`size-5 stroke-2 mr-2`}/>
                            Add event
                        </Button>
                    </div>

                    <Menu as="div" className="relative ml-6 md:hidden">
                        <MenuButton className="-mx-2 flex items-center rounded-full border border-transparent p-2 text-gray-400 hover:text-gray-500">
                            <span className="sr-only">Open menu</span>
                            <EllipsisHorizontalIcon className="size-5" aria-hidden="true" />
                        </MenuButton>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-3 w-36 origin-top-right divide-y divide-gray-100 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <Button
                                        // href="#"
                                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                    >
                                        Create event
                                    </Button>
                                </MenuItem>
                            </div>
                            <div className="py-1">
                                <MenuItem>
                                    <Button
                                        // href="#"
                                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                    >
                                        Go to today
                                    </Button>
                                </MenuItem>
                            </div>
                            <div className="py-1">
                                <MenuItem>
                                    <Button
                                        // href="#"
                                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                    >
                                        Day view
                                    </Button>
                                </MenuItem>
                                <MenuItem>
                                    <Button
                                        // href="#"
                                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                    >
                                        Week view
                                    </Button>
                                </MenuItem>
                                <MenuItem>
                                    <Button
                                        // href="#"
                                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                    >
                                        Month view
                                    </Button>
                                </MenuItem>
                                <MenuItem>
                                    <Button
                                        // href="#"
                                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                    >
                                        Year view
                                    </Button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                </div>
            </header>

            {/*Calendar*/}
            <div className={`${darkMode ? 'border-neutral-700' : ''} border mb-16 rounded-lg shadow-lg lg:flex lg:flex-auto lg:flex-col`}>

                {/*Top*/}
                <div className={`rounded-t-lg grid grid-cols-7 gap-px border-b ${darkMode ? 'border-neutral-700' : 'border-gray-300'} text-center text-xs/6 font-semibold lg:flex-none`}>
                    <div className={`rounded-tl-lg ${darkMode ? 'bg-bgDark' : 'bg-white '} py-2`}>
                        S<span className="sr-only sm:not-sr-only">un</span>
                    </div>
                    <div className={`${darkMode ? 'bg-bgDark' : 'bg-white '} py-2`}>
                        M<span className="sr-only sm:not-sr-only">on</span>
                    </div>
                    <div className={`${darkMode ? 'bg-bgDark' : 'bg-white '} py-2`}>
                        T<span className="sr-only sm:not-sr-only">ue</span>
                    </div>
                    <div className={`${darkMode ? 'bg-bgDark' : 'bg-white '} py-2`}>
                        W<span className="sr-only sm:not-sr-only">ed</span>
                    </div>
                    <div className={`${darkMode ? 'bg-bgDark' : 'bg-white '} py-2`}>
                        T<span className="sr-only sm:not-sr-only">hu</span>
                    </div>
                    <div className={`${darkMode ? 'bg-bgDark' : 'bg-white '} py-2`}>
                        F<span className="sr-only sm:not-sr-only">ri</span>
                    </div>
                    <div className={`rounded-tr-lg ${darkMode ? 'bg-bgDark' : 'bg-white '} py-2`}>
                        S<span className="sr-only sm:not-sr-only">at</span>
                    </div>
                </div>

                {/*Body*/}
                <div className={`rounded-b-lg overflow-hidden flex ${darkMode ? '' : ''} text-xs/6 lg:flex-auto`}>
                    <div className={`hidden w-full lg:grid lg:grid-cols-7 ${gridRowClass} lg:gap-px`}>
                        {days.map((day) => (
                            <div
                                key={day.date}
                                className={classNames(
                                    day.isCurrentMonth ? `${darkMode ? 'bg-bgDark' : 'bg-white'}` : `${darkMode ? 'bg-bgcolor' : 'bg-gray-100'} text-gray-500`,
                                    'relative px-3 py-2',
                                )}
                            >
                                <time
                                    dateTime={day.date}
                                    className={
                                        day.isToday
                                            ? 'flex size-6 items-center animate-zoomFlipBounce justify-center rounded-full bg-green-600 font-semibold text-white'
                                            : undefined
                                    }
                                >
                                    {day.date.split('-').pop().replace(/^0/, '')}
                                </time>
                                {day.events.length > 0 && (
                                    <ol className="mt-2">
                                        {day.events.slice(0, 2).map((event) => (
                                            <li key={event.id}>
                                                <Link to={event.href} className="group flex items-center">
                                                    <TrashIcon className={`${event.custom ? 'visible' : 'hidden'} mr-0.5 size-3 text-red-500`}/>
                                                    <p className="flex-auto truncate font-medium group-hover:text-green-600">
                                                        {event.name}
                                                    </p>
                                                    <time
                                                        dateTime={event.datetime}
                                                        className="ml-3 hidden flex-none text-gray-500 group-hover:text-green-600 xl:block"
                                                    >
                                                        {event.time}
                                                    </time>
                                                </Link>
                                            </li>
                                        ))}
                                        {day.events.length > 2 && <li className="text-gray-500">+ {day.events.length - 2} more</li>}
                                    </ol>
                                )}
                            </div>
                        ))}
                    </div>
                    <div className={`bg-bgDark isolate grid w-full h-[calc(100vh-11.75rem)] grid-cols-7 ${gridRowClass} gap-px lg:hidden`}>
                        {days.map((day) => (
                            <button
                                key={day.date}
                                type="button"
                                className={classNames(
                                    day.isCurrentMonth ? `${darkMode ? 'bg-bgDark' : 'bg-white'}` : `${darkMode ? 'bg-bgcolor' : 'bg-gray-100'} text-gray-500`,
                                    (day.isSelected || day.isToday) && 'font-semibold',
                                    day.isSelected && 'text-white',
                                    !day.isSelected && day.isToday && 'text-green-600',
                                    !day.isSelected && day.isCurrentMonth && !day.isToday && '',
                                    !day.isSelected && !day.isCurrentMonth && !day.isToday && '',
                                    'flex h-full flex-col px-3 py-2 hover:bg-green-600/15 focus:z-10',
                                )}
                            >
                                <time
                                    dateTime={day.date}
                                    className={classNames(
                                        day.isSelected && 'flex size-6 items-center justify-center rounded-full',
                                        day.isSelected && day.isToday && 'bg-indigo-600',
                                        day.isSelected && !day.isToday && 'bg-gray-900',
                                        'ml-auto',
                                    )}
                                >
                                    {day.date.split('-').pop().replace(/^0/, '')}
                                </time>
                                <span className="sr-only">{day.events.length} events</span>
                                {day.events.length > 0 && (
                                    <span className="-mx-0.5 mt-auto flex flex-wrap-reverse">
                                        {day.events.map((event) => (
                                            <span key={event.id} className="mx-0.5 mb-1 size-1.5 rounded-full bg-green-600 animate-pulse" />
                                        ))}
                                    </span>
                                )}
                            </button>
                        ))}
                    </div>
                </div>

            </div>

            {selectedDay?.events.length > 0 && (
                <div className="px-4 py-10 sm:px-6 lg:hidden">
                    <ol className="divide-y divide-gray-100 overflow-hidden rounded-lg bg-white text-sm shadow ring-1 ring-black/5">
                        {selectedDay.events.map((event) => (
                            <li key={event.id} className="group flex p-4 pr-6 focus-within:bg-gray-50 hover:bg-gray-50">
                                <div className="flex-auto">
                                    {/*<TrashIcon className={`${event.custom ? 'visible' : 'hidden'} size-4 text-red-500`}/>*/}
                                    <p className="font-semibold text-gray-900">{event.name}</p>
                                    <time dateTime={event.datetime} className="mt-2 flex items-center text-gray-700">
                                        <ClockIcon className="mr-2 size-5 text-gray-400" aria-hidden="true" />
                                        {event.time}
                                    </time>
                                </div>
                                <Link
                                    to={event.href}
                                    className="ml-6 flex-none self-center rounded-md bg-white px-3 py-2 font-semibold text-gray-900 opacity-0 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400 focus:opacity-100 group-hover:opacity-100"
                                >
                                    Edit<span className="sr-only">, {event.name}</span>
                                </Link>
                            </li>
                        ))}
                    </ol>
                </div>
            )}


            {/*Sidebar*/}
            <Dialog open={isCollapsed} onClose={setIsCollapsed} className={`relative z-50 ${darkMode ? 'text-white' : 'text-black'}`}>
                <div className="fixed inset-0" />

                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/20 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
                />

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 py-3 pr-3">
                            <DialogPanel
                                transition
                                className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                            >
                                <div className={`flex h-full flex-col overflow-y-scroll scrollbar-none border ${darkMode ? 'bg-bgDark border-neutral-700' : 'bg-white'} rounded-lg shadow-2xl`}>


                                    {/*Drawer Header*/}
                                    <div className={`${darkMode ? ' border-neutral-700' : ''} border-b-2 border-dashed px-4 py-4 sm:px-6`}>
                                        <div className="flex items-center justify-between">
                                            <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                                                <CalendarDaysIcon aria-hidden="true" className="size-6 text-green-600" />
                                            </div>

                                            <DialogTitle className="text-base font-semibold tracking-widest">
                                                Event Form
                                            </DialogTitle>

                                            <div className="ml-3 flex h-7 items-center">
                                                <Button
                                                    type="button"
                                                    onClick={clearForm}
                                                    className="relative rounded-md hover:text-red-500 hover:animate-heartbeat"
                                                >
                                                    <span className="absolute -inset-2.5" />
                                                    <span className="sr-only">Clear Form</span>
                                                    <XCircleIcon aria-hidden="true" className="size-6" />
                                                </Button>
                                            </div>
                                        </div>
                                    </div>


                                    {/*Drawer Content*/}
                                    <div className="relative flex-1 px-4 sm:px-6">


                                        <form onSubmit={handleSubmit} className="mt-2 py-3 rounded-lg overflow-y-auto max-h-[calc(100vh-7rem)] scrollbar-none animate-fadeIn grid grid-cols-1 gap-x-3 gap-y-4 sm:max-w-xl sm:grid-cols-6">


                                            <div className="sm:col-span-full relative justify-center items-center text-center tracking-widest text-xs">IDENTIFIERS</div>

                                            {/*Name*/}
                                            <div className="sm:col-span-full relative flex">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Name
                                                </label>
                                                <Input
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    placeholder="Enter Event Name..."
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                />
                                            </div>

                                            {/*Date*/}
                                            <div className="sm:col-span-3 relative flex items-center justify-center">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Date
                                                </label>
                                                <Input
                                                    type="Date"
                                                    id="date"
                                                    name="date"
                                                    placeholder="Enter Date..."
                                                    value={formData.date || currentDate}
                                                    onChange={handleChange}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                />
                                            </div>

                                            {/*Time*/}
                                            <div className="sm:col-span-3 relative flex items-center justify-center">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Time
                                                </label>
                                                <Input
                                                    type="time"
                                                    id="time"
                                                    name="time"
                                                    placeholder="Enter Time..."
                                                    value={formData.time || '12:00'}
                                                    onChange={handleChange}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                />
                                            </div>

                                            {/*Event Type*/}
                                            <div className="sm:col-span-full relative flex items-center justify-start">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Event Type
                                                </label>
                                                <Select
                                                    type="text"
                                                    id="type"
                                                    name="type"
                                                    value={formData.type}
                                                    onChange={handleChange}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-2.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                >
                                                    <option value="">Select...</option>

                                                    <option value="Delivery">Delivery</option>
                                                    <option value="Outing">Outing</option>
                                                    <option value="Holiday">Holiday</option>
                                                    <option value="Day Off">Day Off</option>
                                                </Select>
                                            </div>


                                            <div className={`sm:col-span-full ${darkMode ? "text-darkgreen" : "text-gray-400"} font-bold justify-center items-center text-center text-xxs`}>This
                                                is the data that the system uses to identify this chemical in your
                                                database
                                            </div>

                                            <div className="sm:col-span-full justify-center items-center text-center tracking-widest text-xs">NOTES</div>

                                            {/*Notes*/}
                                            <div className="sm:col-span-full relative flex items-center justify-start">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Notes
                                                </label>
                                                <Textarea
                                                    type="text"
                                                    id="notes"
                                                    name="notes"
                                                    value={formData.notes}
                                                    onChange={handleChange}
                                                    className={`block w-full h-24 overflow-y-scroll scrollbar-none ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                >

                                                </Textarea>
                                            </div>


                                            <Button type="submit" className="sm:col-span-full bg-green-600 tracking-widest hover:bg-opacity-50 text-white py-1 px-4 rounded-lg focus:outline-none focus:shadow-outline">
                                                {addOrUpdateButtonText}
                                            </Button>


                                        </form>


                                    </div>


                                </div>
                            </DialogPanel>
                        </div>
                    </div>
                </div>
            </Dialog>


            {/*Time Machine Selector*/}
            <Dialog open={timeMachine} onClose={setTimeMachine} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`relative transform overflow-hidden rounded-lg ${darkMode ? 'bg-bgDark text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                        >
                            <div className="sm:flex sm:items-start">
                                <div
                                    className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                                    <CalendarDateRangeIcon aria-hidden="true" className="size-6 text-green-600"/>
                                </div>
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold">
                                        Time Machine
                                    </DialogTitle>
                                    <div className="mt-2 space-y-2">
                                        <p className="text-sm text-gray-500">
                                            Easily navigate through time by selecting any month and year from the
                                            dropdown. Instantly update the calendar view to display your activity for
                                            that selected period!
                                        </p>

                                        <div className={`w-full flex gap-3`}>
                                            <Select
                                                value={month}
                                                onChange={e => setMonth(parseInt(e.target.value))}
                                                className={`border w-full px-2 py-1 rounded tracking-widest ${darkMode ? 'bg-bgDark border-neutral-700' : 'bg-white'}`}
                                            >
                                                {MONTHS.map((m, idx) => (
                                                    <option key={idx} value={idx}>{m}</option>
                                                ))}
                                            </Select>

                                            <Select
                                                value={year}
                                                onChange={e => setYear(parseInt(e.target.value))}
                                                className={`border w-full px-2 py-1 rounded tracking-widest ${darkMode ? 'bg-bgDark border-neutral-700' : 'bg-white'}`}
                                            >
                                                {YEARS.map((y) => (
                                                    <option key={y} value={y}>{y}</option>
                                                ))}
                                            </Select>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <Button
                                    type="button"
                                    onClick={() => setTimeMachine(false)}
                                    className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto"
                                >
                                    Jump
                                </Button>
                                <Button
                                    type="button"
                                    onClick={() => {
                                        setYear(today.getFullYear());
                                        setMonth(today.getMonth());
                                        setTimeMachine(false);
                                    }}
                                    className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-bgpage' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>


        </div>
    )
}

export default MonthView
